// extracted by mini-css-extract-plugin
module.exports = {"deliver":"styles_deliver__TdlC2","pulse":"styles_pulse__9Tu6I","jump":"styles_jump__pHS8m"};